import { Box, Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CompletionConfigurationFields } from 'modules/trainings/components/Revamp/CompletionConfigurationFields'

import { TrainingWizardData } from './types'

interface CompletionConfigurationStepProps {
  data: TrainingWizardData
  onDataChanged: (data: TrainingWizardData) => void
}

export const CompletionConfigurationStep = ({
  data,
  onDataChanged,
}: CompletionConfigurationStepProps) => {
  return (
    <Box flexDirection="row" gap="s24">
      <Box gap="s24" paddingX="s16">
        <Title
          variant="500"
          title={i18n.t(
            'trainings.trainings_revamp.new_training.wizard.completion_configuration.step_title'
          )}
          description={i18n.t(
            'trainings.trainings_revamp.new_training.wizard.completion_configuration.description'
          )}
        />
        <CompletionConfigurationFields
          data={{
            attendancePercentage: data.attendancePercentage,
            moduleCompletedPercentage: data.moduleCompletedPercentage,
            knowledgeTestRequired: data.knowledgeTestRequired,
          }}
          onDataChanged={(newData) => onDataChanged({ ...data, ...newData })}
        />
      </Box>
    </Box>
  )
}
